/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITeamResponse } from './ITeamResponse';
import {
    ITeamResponseFromJSON,
    ITeamResponseFromJSONTyped,
    ITeamResponseToJSON,
    ITeamResponseToJSONTyped,
} from './ITeamResponse';

/**
 * 
 * @export
 * @interface GetCompetitionTeamResponse
 */
export interface GetCompetitionTeamResponse {
    /**
     * 
     * @type {ITeamResponse}
     * @memberof GetCompetitionTeamResponse
     */
    team: ITeamResponse;
}

/**
 * Check if a given object implements the GetCompetitionTeamResponse interface.
 */
export function instanceOfGetCompetitionTeamResponse(value: object): value is GetCompetitionTeamResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function GetCompetitionTeamResponseFromJSON(json: any): GetCompetitionTeamResponse {
    return GetCompetitionTeamResponseFromJSONTyped(json, false);
}

export function GetCompetitionTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompetitionTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': ITeamResponseFromJSON(json['team']),
    };
}

export function GetCompetitionTeamResponseToJSON(json: any): GetCompetitionTeamResponse {
    return GetCompetitionTeamResponseToJSONTyped(json, false);
}

export function GetCompetitionTeamResponseToJSONTyped(value?: GetCompetitionTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': ITeamResponseToJSON(value['team']),
    };
}

